/* eslint-disable */
import Vue from 'vue';
import toast from '@/views/dl-web/Toast';

const Toast = Vue.extend(toast);
let instance;
let timer = null; // 定义定时器
const toastMsg = (options) => { // options参数，定义提示框的类型，提示文字，停留时间
  if (!instance) {
    instance = new Toast(); // 创建toast实例
    document.body.append(instance.$mount().$el); // 将toast实例挂在到页面中
  }
  instance.duration = 2000; // 定义默认停留时间
  if (typeof options === 'string') {
    instance.message = options;
  } else if (typeof options === 'object') {
    instance.type = options.type;
    instance.message = options.message || '报错啦';
    instance.duration = options.duration || 2000;
    instance.customClass = options.customClass || '';
    instance.dangerouslyUseHTMLString = options.dangerouslyUseHTMLString || false;
  } else {
    return;
  }
  instance.show = true;
  timer = setTimeout(() => {
    instance.show = false;
    clearTimeout(timer);
    timer = null;
  }, instance.duration);
};

export default toastMsg;

// 在需要的地方直接用以下方法调用即可：
// import toast from '@/utils/toast';
// toast({
// type: 'success',
// message: '',
// duration: 5000
// })
